import styled from 'styled-components'

const PageBox = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	position: relative;
`

export { PageBox }
